import request from '@/utils/request'

/**
 * @file 运维工作台接口
 */


/**
 * 电站告警统计
 */
export function queryStatisticalData() {
  return request({
    url: '/dashboard/v3/ops/operation/console/queryStatisticalData',
    method: 'get',
  })
}


/**
 * 工单列表
 * @param {Object} params 查询参数
 * @param {number} params.limit 查询的数据条数，1~100，默认10
 * @param {string} params.dateId 分页符，上一次查询数据结果的最后一条数据的ID，没有则留空
 * @returns 
 */
export function getWorkOrderList(params) {
  return request({
    url: '/dashboard/v3/ops/operation/console/wo/list',
    method: 'get',
    params: params
  })
}


/**
 * 工单分页列表
 * @param {Object} params 查询参数
 * @param {number} params.pageNum 页码，默认1
 * @param {string} params.pageSize 分页大小，默认10
 * @returns 
 */
export function getWorkOrderPage(params) {
  return request({
    url: '/dashboard/v3/ops/operation/console/wo/page',
    method: 'get',
    params: params
  })
}



/**
 * 工单总数
 */
export function queryWorkOrderTotal() {
  return request({
    url: '/dashboard/v3/ops/operation/console/wo/queryTotal',
    method: 'get',
  })
}



/**
 * 工单创建
 * @param {Object} data 
 * @returns 
 */
export function createWorkOrder(data) {
  return request({
    url: '/dashboard/v3/ops/operation/console/wo/create',
    method: 'post',
    data: data
  })
}



/**
 * 告警详情
 * @param {object} params
 * @param {string} params.messageId 告警ID
 * @param {string} params.uuid 设备UUID
 * @returns
 */
export function queryAlarmDetail(params) {
  return request({
    url: '/dashboard/v3/ops/operation/console/queryAlarm',
    method: 'get',
    params: params
  })
}


/**
 * 运营待办事项列表
 * @param {Object} params 查询参数
 * @returns
 */
export function getOMTodoList(params) {
  return request({
    url: '/device/v3/station/approval/todo/list',
    method: 'get',
    params: params
  })
}

/**
 * 已审批电站列表（用于 jd-develop / jd-project 视角的电站申请卡片）
 * 前端需过滤 status !== 0 且 applicantRead === 0 的记录
 * @param {Object} params 查询参数
 * @returns
 */
export function getApprovedStationList(params) {
  return request({
    url: '/device/v3/station/approval/my/list',
    method: 'get',
    params: params
  })
}
